require('jquery-mask-plugin');

setMask = function () {
    var SPMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 9 ? '00000-0000' : '0000-00009';
    }, spOptions = {
        onKeyPress: function (val, e, field, options) {
            field.mask(SPMaskBehavior.apply({}, arguments), options);
        }
    };

    $('input.zip_code').mask('00000-000').attr({'placeholder': '00000-000'});
    $('input.phone').mask(SPMaskBehavior, spOptions).attr({'placeholder': '0000-0000'});
    $('input.cpf').mask('000.000.000-00', {reverse: true}).attr({'placeholder': '000.000.000-00'});
    $('input.cnpj').mask('00.000.000/0000-00', {reverse: true}).attr({'placeholder': '00.000.000/0000-00'});
    $('input.currency').mask('000.000.000.000.000,00', {reverse: true}).attr({'placeholder': '0,00'});
    $('input.cpf_cnpj').on('blur', function () {
        var $input = $(this);
        var length = getNumbers($input.val()).length;
        if (length === 11) {
            $input.mask('000.000.000-00', {reverse: true});
        } else if (length === 14) {
            $input.mask('00.000.000/0000-00', {reverse: true});
        } else {
            $input.unmask().val('');
        }
    }).on('focus', function () {
        $(this).unmask();
    }).attr({'placeholder': 'CPF ou CNPJ'});
};

$('document').ready(function () {
    setMask();
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-add-mask.js